import { render } from "./Verified.vue?vue&type=template&id=62f2ffd7&scoped=true"
const script = {}

import "./Verified.vue?vue&type=style&index=0&id=62f2ffd7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-62f2ffd7"

export default script